/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_sidebar_menu_persons = /** @type {(inputs: {}) => string} */ () => {
	return `Personas`
};

const en_sidebar_menu_persons = /** @type {(inputs: {}) => string} */ () => {
	return `Persons`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sidebar_menu_persons = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sidebar_menu_persons(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sidebar_menu_persons", locale)
	if (locale === "es") return es_sidebar_menu_persons(inputs)
	return en_sidebar_menu_persons(inputs)
};
export { sidebar_menu_persons as "sidebar.menu.persons" }